import { IoLocationSharp } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";

export default function ContactInfo() {
	return (
		<div
			className="relative w-full py-16 lg:py-24 flex items-center justify-center 
                       overflow-hidden bg-white-900 min-h-[20vh]"
		>
			<div className="relative z-10 container mx-auto px-6">
				<div className="grid md:grid-cols-3 gap-8 md:gap-12 items-stretch text-black">
					<div
						className="flex flex-col items-center justify-start p-8 
                       bg-black/10 hover:bg-black/20 transition duration-300 
                       rounded-xl shadow-2xl backdrop-blur-sm h-full text-center"
					>
						<IoLocationSharp size={40} color="#cbbca3" className="mb-4" />

						<p>
							47 Poniente 707 INT. 202 Col. Prados Agua Azul, Puebla de
							Zaragoza, México C.P. 72430
						</p>
					</div>
					<div
						className="flex flex-col items-center justify-start p-8 
                       bg-black/10 hover:bg-black/20 transition duration-300 
                       rounded-xl shadow-2xl backdrop-blur-sm h-full text-center"
					>
						<MdEmail size={40} color="#cbbca3" className="mb-4" />

						<p>comercializadora.1102@gmail.com</p>
					</div>
					<div
						className="flex flex-col items-center justify-start p-8 
                       bg-black/10 hover:bg-black/20 transition duration-300 
                       rounded-xl shadow-2xl backdrop-blur-sm h-full text-center"
					>
						<FaPhone size={40} color="#cbbca3" className="mb-4" />

						<p>(+52) 222 554 8923</p>
					</div>
				</div>
			</div>
		</div>
	);
}
